import { render, staticRenderFns } from "./CarIdentification.vue?vue&type=template&id=5c779439&"
import script from "./CarIdentification.vue?vue&type=script&lang=js&"
export * from "./CarIdentification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports